import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './VendorDetails.css';
import AdminSidebar from '../components/AdminSidebar'; 

function VendorDetails() {
  const [vendors, setVendors] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [expanded, setExpanded] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetch('https://ideatorportal.in/api/get_all_vendors.php')
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success' && Array.isArray(data.vendors)) {
          const grouped = {};
          data.vendors.forEach(v => {
            const name = v.vendor_name.trim();
            const materials = Array.isArray(v.materials) ? v.materials : [];
            const id = v.id;
            if (!grouped[name]) {
              grouped[name] = {
                vendor_name: name,
                id: id,
                total_amount: parseFloat(v.total_amount || 0),
                materials: materials,
              };
            } else {
              grouped[name].total_amount += parseFloat(v.total_amount || 0);
              grouped[name].materials = grouped[name].materials.concat(materials);
            }
          });
          setVendors(Object.values(grouped));
        } else {
          setError('Failed to load vendor data.');
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading vendors:', err);
        setError('Network error while loading vendors.');
        setLoading(false);
      });
  }, []);

  const filtered = vendors.filter(v =>
    v.vendor_name.toLowerCase().includes(search.toLowerCase())
  );

  const toggleExpand = (vendorName) => {
    setExpanded(prev => ({ ...prev, [vendorName]: !prev[vendorName] }));
  };

  const calculateMaterialTotal = (qty, price, gst) => {
    const quantity = parseFloat(qty || 0);
    const unitPrice = parseFloat(price || 0);
    const gstRate = parseFloat(gst || 0);
    return quantity * unitPrice * (1 + gstRate / 100); 
  };
  

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="vendor-details-container">
        <h2 className="heading">Vendor Details</h2>

        <input
          type="text"
          placeholder="Search Vendor..."
          className="search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {loading && <p className="loading">Loading vendors...</p>}
        {error && <p className="error">{error}</p>}
        {!loading && !error && filtered.length === 0 && (
          <p className="no-data">No vendors found.</p>
        )}

        {!loading && !error && filtered.length > 0 && (
          <table className="vendor-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Vendor Name</th>
                {/* <th>Total Amount</th> */}
              </tr>
            </thead>
            <tbody>
              {filtered.map((vendor, index) => (
                <React.Fragment key={vendor.vendor_name}>
                  <tr className="vendor-row" onClick={() => toggleExpand(vendor.vendor_name)}>
                    <td>{index + 1}</td>
                    <td>
                      <span
                        className="vendor-link"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/admin/vendor/${vendor.id}`);
                        }}
                      >
                        {vendor.vendor_name}
                      </span>
                    </td>
                    {/* <td>₹{vendor.total_amount.toFixed(2)}</td> */}
                  </tr>
                  {expanded[vendor.vendor_name] && Array.isArray(vendor.materials) && vendor.materials.length > 0 && (
                    <tr className="materials-row">
                      <td colSpan="3">
                        <div className="materials-table-wrapper">
                          <table className="materials-table">
                            <thead>
                              <tr>
                                <th>Item</th>
                                <th>Unit</th>
                                <th>Qty</th>
                                <th>Price</th>
                                <th>GST%</th>
                                <th>Total (incl. GST)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vendor.materials.map((mat, idx) => (
                                <tr key={idx}>
                                  <td>{mat.item_name}</td>
                                  <td>{mat.unit}</td>
                                  <td>{mat.quantity}</td>
                                  <td>₹{parseFloat(mat.price || 0).toFixed(2)}</td>
                                  <td>{mat.gst || 0}%</td>
                                  <td>₹{calculateMaterialTotal(mat.quantity, mat.price, mat.gst).toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default VendorDetails;
